import React from 'react';
import PropTypes from 'prop-types';

import {AppFlags} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {frefFromRef} from '../../../lib/react/higher-order-components';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OENavigationViewComponent} from '../../../lib/components/oe-navigation-controller';
import OEFlowNavModal from '../flow-nav/oe-flow-nav-modal';
import {OEFNWelcomePropDecl} from '../flow-nav/welcome/oe-fn-welcome-model';
import OEFNWelcome from '../flow-nav/welcome/oe-flow-nav-welcome';
import {OEFNHelpPropTypes, OEFNHelpEntryFactory} from '../flow-nav/help/oe-flow-nav-help-model';
import OEFNHelp from '../flow-nav/help/oe-flow-nav-help';
import OEFlowNavStartSelectionView from '../flow-nav/start-selection/oe-flow-nav-start-selection-view';

export class OEFNStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.options = this.props.options;

        this.ref = null;

        this.state = {
            options:                this.options,
            showCloseBtnAllways:    this.options === 'help' || this.options === 'info-help' || this.options === 'start-selection' || this.props.showCloseBtnAllways,
        };

        this.onRef = this.onRef.bind(this);

        this.onOptionsChanged = this.onOptionsChanged.bind(this);
        this.onStartSelectionItemClick = this.onStartSelectionItemClick.bind(this);
    }

    updateShowNavButtonAllways(props) {
        props = props || this.props;
        this.setState({showCloseBtnAllways: this.options === 'help' || this.options === 'info-help' || this.options === 'start-selection' || this.props.showCloseBtnAllways});
    }

    onRef(ref)  {
        if(this.ref !== ref) {
            this.ref = ref;
            this.setState({parent: ref});

            if(ref && this.options !== ref.options)    {
                this.options = ref.options;
                this.setState({options: this.options, showCloseBtnAllways: this.options === 'help' || this.options === 'info-help' || this.options === 'start-selection' || this.props.showCloseBtnAllways});
            }
        }
        if(this.props.fref) this.props.fref(ref);
    }

    renderViewComponent()   {
        let hasUndeferredChilds = false;
        React.Children.forEach(this.props.children, (child) => {
            if(!child.props.deferred)   hasUndeferredChilds = true;
        });
        if(hasUndeferredChilds) return null;

        if(this.state.options === 'help')   {
            let help = Object.assign({
                locStringPrefix:        this.props.locStringPrefix,
                autoSpacerHeight:       this.props.autoSpacerHeight,
            }, this.props.help);

            return (
                <OENavigationViewComponent title="help_view_title">
                    <OEFNHelp
                        target={this.props.target}
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        {...help}
                        parent={this.state.parent}
                    />
                </OENavigationViewComponent>
            );
        }

        if(this.state.options === 'info-help')   {
            let infoHelp = Object.assign({
                locStringPrefix:        this.props.locStringPrefix,
                autoSpacerHeight:       this.props.autoSpacerHeight,
                version:                true,
                versionForDev:          true
            }, this.props.infoHelp);

            return (
                <OENavigationViewComponent title="help_info_view_title">
                    <OEFNHelp
                        target={this.props.target}
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        {...infoHelp}
                        devFeatures={this.props.devFeatures}
                        parent={this.state.parent}
                    />
                </OENavigationViewComponent>
            );
        }

        if(this.state.options === 'start-selection')   {
            return (
                <OENavigationViewComponent
                    title={{titleId: 'welcome_view_start_selection', icon: OEIconCodes.startSelection}}
                    showLogo={true}
                >
                    <OEFlowNavStartSelectionView
                        moduleId={this.props.moduleId}
                        locStringPrefix={this.props.locStringPrefix}
                        onItemClick={this.onStartSelectionItemClick}
                    />
                </OENavigationViewComponent>
            );
        }

        return (
            <OENavigationViewComponent title="welcome_view_title">
                <OEFNWelcome
                    target={this.props.target}
                    appComponent={this.props.appComponent}
                    moduleId={this.props.moduleId}
                    locStringPrefix={this.props.locStringPrefix}
                    entries={this.props.entries}
                    autoSpacerHeight={this.props.autoSpacerHeight}
                    parent={this.state.parent}
                    help={this.props.help}
                />
            </OENavigationViewComponent>
        );
    }

    render() {
        const {fref, onOptionsChanged, showCloseBtnAllways, locStringPrefix, entries, className, ...rest} = this.props;

        return (
            <OEFlowNavModal
                {...rest}
                className={'start-view ' + className}
                ref={this.onRef}
                onOptionsChanged={this.onOptionsChanged}
                showCloseBtnAllways={this.state.showCloseBtnAllways}
            >
                {this.renderViewComponent()}
                {this.props.children}
            </OEFlowNavModal>
        );
    }

    onOptionsChanged(sender, options)  {
        if(this.options !== options)    {
            this.options = options;
            this.setState({options: this.options, showCloseBtnAllways: this.options === 'help' || this.options === 'info-help' || this.options === 'start-selection' || this.props.showCloseBtnAllways});
        }
        if(this.props.onOptionsChanged) this.props.onOptionsChanged(sender, options);
    }

    onStartSelectionItemClick(sender, item) {
        if(!item.target)    return;

        if(this.ref && this.options === 'start-selection')  {
            this.ref.close();
            return;
        }
    }
}

OEFNStartView.defaultProps = Object.assign({}, OEFlowNavModal.defaultProps, OEFNWelcome.defaultProps,
    {
        help: {
            showLogo:           false,
            entries:            OEFNHelpEntryFactory.buildDef(),
            autoSpacerHeight:   OEFNHelp.defaultProps.autoSpacerHeight
        },
        infoHelp: {
            entries:            OEFNHelpEntryFactory.buildDefInfoHelp(),
            autoSpacerHeight:   OEFNHelp.defaultProps.autoSpacerHeight
        }
    }
);

OEFNStartView.propTypes = Object.assign({}, OEFlowNavModal.propTypes, OEFNWelcomePropDecl,
    {
        help: PropTypes.shape(Object.assign({
            showLogo:           PropTypes.bool
        }, OEFNHelpPropTypes.propTypes)),
        infoHelp:               PropTypes.shape(OEFNHelpPropTypes.propTypes)
    }
);

export default frefFromRef(connectAppEnv((env) => { return {
    target:                     env.config.target,
    appComponent:               env.component,
    devFeatures:                env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
}})(OEFNStartView));
